import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BusinessIcon from "@mui/icons-material/Business";
import LoyaltyModal from "./LoyaltyModal";
import LoyaltyChips from "./LoyaltyChips";
import {
  BusinessGroup,
  rewardsReadyCount,
  sharedReachText,
} from "../../utils/loyaltyBusiness";
import styles from "./Portal.module.scss";

/** One loyalty card for a business whose locations share points. */
const BusinessLoyaltyCard: React.FC<{ group: BusinessGroup }> = ({
  group: { business, loyalty, loyaltyLocation },
}) => {
  const [loyaltyOpen, setLoyaltyOpen] = useState(false);
  const navigate = useNavigate();
  const hasPunchCards = (loyaltyLocation.punchCards ?? []).length > 0;

  return (
    <>
      <div className={styles.Card}>
        <div className={styles.CardTop}>
          <div className={styles.CardLogoPlaceholder}>
            <BusinessIcon className={styles.BusinessIcon} />
          </div>
          <div className={styles.CardBody}>
            <p className={styles.CardName}>{business.name}</p>
            <p className={styles.CardCity}>{sharedReachText(business)}</p>
            <LoyaltyChips
              loyalty={loyalty}
              rewardsReady={rewardsReadyCount(loyaltyLocation)}
            />
          </div>
        </div>

        <div className={styles.CardActions}>
          <button
            className={`${styles.CardAction} ${styles.CardActionSecondary}`}
            type="button"
            onClick={() => setLoyaltyOpen(true)}
          >
            Loyalty
          </button>
          {hasPunchCards && (
            <button
              className={`${styles.CardAction} ${styles.CardActionSecondary}`}
              type="button"
              onClick={() =>
                navigate(`/location/${loyaltyLocation.id}/punch-cards`)
              }
            >
              Punch cards
            </button>
          )}
        </div>
      </div>

      <LoyaltyModal
        active={loyaltyOpen}
        locationId={loyaltyLocation.id}
        locationName={loyaltyLocation.name}
        loyalty={loyalty}
        currency={loyaltyLocation.currency ?? ""}
        onClose={() => setLoyaltyOpen(false)}
      />
    </>
  );
};

export default BusinessLoyaltyCard;
